import { useAuth } from 'context/AuthProvider'
import React, {  useState } from 'react'
import { Button, Col, Row, Spinner } from 'reactstrap';
import FichajesHoyImpl from './FichajesHoyImpl';
import { apiFichajesService } from 'services/apiFichajesService';
import { showAppAlert } from "components/common/AppAlerts";

const Fichar = () => {
    const {empleado} =useAuth();
    const [update, setUpdate] = useState(false);

    const [loading, setLoading] = useState(false);


    const [ultimoFichajeEsEntrada, setUltimoFichajeEsEntrada] = useState(false)


    


    const handleEntrada = async () =>{
      try {

        setLoading(true)
        let json = {}
        await obtenerUbicacion().then((coord) => {
          json = { "empleadoId": empleado.id, empresaId: empleado.empresaId, "tipo": "entrada", "latitud": coord?.latitud || 0.0, "longitud": coord?.longitud || 0.0 , origen :"app"};
          
        }).catch(() => {
          json = { "empleadoId": empleado.id, empresaId: empleado.empresaId, "tipo": "entrada", "latitud": 0.0, "longitud": 0.0, origen :"app" };
        });
        const response = await apiFichajesService.fichar(json)
      
      } catch (error) {
        showAppAlert("Error al fichar: " + (error.body || error.message), "error");
      }finally {
        setLoading(false)
        setUpdate(!update)
      }
        
    }
    const handleSalida = async () =>{
       try {

        setLoading(true)
        let json = {}
        await obtenerUbicacion().then((coord) => {
          json = { "empleadoId": empleado.id, empresaId: empleado.empresaId, "tipo": "salida", "latitud": coord?.latitud || 0.0, "longitud": coord?.longitud || 0.0 , origen :"app"};
          
        }).catch(() => {
          json = { "empleadoId": empleado.id, empresaId: empleado.empresaId, "tipo": "salida", "latitud": 0.0, "longitud": 0.0, origen :"app" };
        });
         const response = await apiFichajesService.fichar(json)
        
      } catch (error) {
        showAppAlert("Error al fichar: " + (error.body || error.message), "error");
      }finally {
        setLoading(false)
        setUpdate(!update)
      }
    }

    const obtenerUbicacion = async () =>{
        return new Promise((resolve, rejects) => {
            navigator.geolocation.getCurrentPosition(
              (position) => {
                let latitud = position.coords.latitude;
                let longitud = position.coords.longitude;
                resolve({ "latitud": latitud, "longitud": longitud });
              },
              () => {
                rejects({ "latitud": 0.0, "longitud": 0.0 });
              }
            );
          });
    }
  
if(loading){
  return ( <Spinner color="primary">
  Loading...
</Spinner>
)
}

   return (
    <>
        <Row>
            <Col>
                <FichajesHoyImpl update={update} setUltimoFichajeEsEntrada={setUltimoFichajeEsEntrada}></FichajesHoyImpl>
            </Col>
        </Row>
        <Row className='mt-2'>

            <Col >
                <Button color="success" block  className='btn' onClick={() => handleEntrada() } disabled={ultimoFichajeEsEntrada}>Entrar</Button>
            </Col>
            <Col >
                <Button color="danger" block className='btn' onClick={() => handleSalida()} disabled={!ultimoFichajeEsEntrada}>Salir</Button>
            </Col>
        </Row>
    </>
  )
}

export default Fichar
